// extracted by mini-css-extract-plugin
export default {"articleBox":"index_articleBox_xviXY"};